$(document).ready(function() {
  
    // SUPPORT YT VIDEO
    if ($('.assembly-test-section').length || $('.support-video-slider').length) {
      
        $('.youtube-list-container .youtube').each(function() {
            let videoId = $(this).data('yt');
            let thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
            $(this).css('background-image', `url(${thumbnailUrl})`);
        });
      
      const iframes = document.querySelectorAll('.youtube-list-container .youtube');
      
      // Get all video IDs (keeping duplicates for frontend use)
      const allVideoIds = Array.from(iframes).map(iframe => $(iframe).data('yt'));
      
      // Create a unique set for API requests only (to avoid errors)
      const uniqueVideoIds = [...new Set(allVideoIds)];
      
      const localStorageKey = "trouble-shooting-yt:videoData";
      const cachedData = localStorage.getItem(localStorageKey);
      const parsedCache = cachedData ? JSON.parse(cachedData) : { videoIds: [], data: {} };
      
      // Check if stored video IDs are different (based on unique API IDs)
      const isDifferent = JSON.stringify(parsedCache.videoIds) !== JSON.stringify(uniqueVideoIds);
      
      if (!isDifferent && Object.keys(parsedCache.data).length > 0) {
          console.log("Using cached video data.");
          processVideoData(parsedCache.data, allVideoIds);
      } else {
          console.log("Fetching new video data...");
          fetchVideoData(uniqueVideoIds, allVideoIds);
      }
      
      async function fetchVideoData(apiVideoIds, allVideoIds) {
          if (!apiVideoIds.length) {
              console.error("No valid video IDs to fetch.");
              return;
          }
      
          const API_KEY = "AIzaSyAu_MPjsLksQo7Mo9cn1ei1CUFhjDiYKrE"; // Replace with your YouTube API Key
          const maxVideosPerRequest = 50;
          let videoData = { items: [] };
      
          // Split video IDs into chunks of maxVideosPerRequest
          for (let i = 0; i < apiVideoIds.length; i += maxVideosPerRequest) {
              const chunk = apiVideoIds.slice(i, i + maxVideosPerRequest);
              const videosApiUrl = `https://www.googleapis.com/youtube/v3/videos?part=snippet&id=${chunk.join(',')}&key=${API_KEY}`;
      
              try {
                  const response = await fetch(videosApiUrl);
                  const json = await response.json();
      
                  if (json.error) throw new Error(json.error.message);
                  videoData.items.push(...json.items);
              } catch (error) {
                  console.error("Error fetching video data:", error);
                  return;
              }
          }
      
          if (videoData.items.length > 0) {
              localStorage.setItem(localStorageKey, JSON.stringify({ videoIds: apiVideoIds, data: videoData }));
              processVideoData(videoData, allVideoIds);
          } else {
              console.warn("No video data received.");
          }
      }
      
      // Function to process video data and keep duplicates
      function processVideoData(videoData, allVideoIds) {
          if (!videoData.items || videoData.items.length === 0) {
              console.error("No video data found.");
              return;
          }
      
          const videoMap = {};
          videoData.items.forEach(video => {
              videoMap[video.id] = video;
          });
      
          allVideoIds.forEach((videoId, index) => {
              const video = videoMap[videoId];
              if (video) {
                  const titleElement = document.getElementsByClassName('video-title')[index];
                  const authorNameElement = document.getElementsByClassName('author-name')[index];
      
                  if (titleElement) titleElement.textContent = video.snippet.title;
                  if (authorNameElement) authorNameElement.textContent = video.snippet.channelTitle;
              }
          });
      
          const channelIdSet = new Set(videoData.items.map(video => video.snippet.channelId));
          const channelIds = Array.from(channelIdSet);
      
          if (channelIds.length) {
              fetchChannelData(channelIds, videoMap);
          }
      }
      
      // Fetch channel logos only if needed
      async function fetchChannelData(channelIds, videoMap) {
          const channelStorageKey = "trouble-shooting-yt:channelData";
          const cachedChannelData = localStorage.getItem(channelStorageKey);
          const parsedChannelCache = cachedChannelData ? JSON.parse(cachedChannelData) : { channelIds: [], data: {} };
      
          const storedChannelIds = parsedChannelCache.channelIds || [];
          const isChannelDifferent = JSON.stringify(storedChannelIds) !== JSON.stringify(channelIds);
      
          if (!isChannelDifferent && Object.keys(parsedChannelCache.data).length > 0) {
              console.log("Using cached channel data.");
              updateChannelLogos(parsedChannelCache.data, videoMap);
          } else {
              console.log("Fetching new channel data...");
              const API_KEY = "AIzaSyAu_MPjsLksQo7Mo9cn1ei1CUFhjDiYKrE"; // Replace with your YouTube API Key
              const channelsApiUrl = `https://www.googleapis.com/youtube/v3/channels?part=snippet&id=${channelIds.join(',')}&key=${API_KEY}`;
      
              try {
                  const response = await fetch(channelsApiUrl);
                  const channelData = await response.json();
      
                  if (channelData.error) throw new Error(channelData.error.message);
      
                  localStorage.setItem(channelStorageKey, JSON.stringify({ channelIds, data: channelData }));
                  updateChannelLogos(channelData, videoMap);
              } catch (error) {
                  console.error("Error fetching channel data:", error);
              }
          }
      }
      
      // Function to update profile images
      function updateChannelLogos(channelData, videoMap) {
          if (!channelData.items || channelData.items.length === 0) {
              console.error("No channel data found.");
              return;
          }
      
          const channelLogoMap = {};
          channelData.items.forEach(channel => {
              channelLogoMap[channel.id] = channel.snippet.thumbnails.default.url;
          });
      
          Array.from(iframes).forEach((iframe, index) => {
              const videoId = $(iframe).data('yt');
              const video = videoMap[videoId];
              if (video) {
                  const channelId = video.snippet.channelId;
                  const profileImgElement = document.getElementsByClassName('yt-profile')[index];
      
                  if (profileImgElement && channelLogoMap[channelId]) {
                      profileImgElement.src = channelLogoMap[channelId];
                  }
              }
          });
      }



    }
  
    // SUPPORT NAV
    if ($('.navigation-header-section').length) {
      
      $(window).on('resize', function () {
        var headerHeight = $('.header').outerHeight();
    
        $('.navigation-header-container').css('top', headerHeight + 'px');
      }).trigger('resize');
      $('.navigation-header-section').each(function(){
          var $container = $(this); 
          $container.find('.header-menu .list-menu-link').click(function(){
              $('.header-menu .list-menu-link').removeClass('active');
              $(this).addClass('active');
              
              var targetOffset = $('.'+$(this).attr('data-scroll')).offset().top - 120;
              $("html, body").animate({
                  scrollTop: targetOffset
              }, 5);
          });
          
      });
  
      $(window).on('scroll', function() {
          // Get the top offset of the .navigation-header-section
          var productHeaderTop = $('.navigation-header-section').offset().top - 150;
          var scrollPosition = $(window).scrollTop();
  
          // Check the scroll position
          if ($(window).scrollTop() >= productHeaderTop) {
              // Make the .navigation-header-section sticky
              $('.navigation-header-container').addClass('product-header-sticky');
              // Hide the header
              $('.shopify-section-header-sticky').addClass('header-hide');
          } else {
              // Remove the sticky class when scrolling above the section
              $('.navigation-header-container').removeClass('product-header-sticky');
              // Show the header again
              $('.shopify-section-header-sticky').removeClass('header-hide');
          }
          
          $(".section-scroll").each(function() {
              var sectionTop = $(this).offset().top - 150;
              var sectionBottom = sectionTop + $(this).outerHeight();
              var targetButton = $('.product-header-menu .list-menu-link[data-scroll="' + $(this).attr('class').split(' ')[0] + '"]');
              if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
                  targetButton.addClass("active");
              } else {
                  targetButton.removeClass("active");
              }
  
          });
      });
      
    }
  
    // SUPPORT FAQS
    if ($('.support-faqs-section').length) {
      
        $('.support-faqs-section .tab-block').each(function(){
            var $container = $(this); 
            $container.find('.tab-title h5').click(function(){
                $('.support-faqs-section .tab-title h5').removeClass('active');
                $(this).addClass('active');
                $('.support-faqs-section .tab-faqs').hide();
                $('.support-faqs-section .tab-faqs[data-tab="' + $(this).attr('data-tab') + '"]').show();
               
            });
        });
    }

    // SUPPORT VIDEO SLIDER
    if ($('.support-video-slider').length) {
  
        $('.support-video-slider .owl-carousel').each(function() {
              let $carousel = $(this);
              let $floatNav = $carousel.next('.float-nav');
      
              let owl = $carousel.owlCarousel({
                  items: 4,
                  nav: true,
                  dots: true,
                  smartSpeed: 800,
                  margin: 15,
                  responsive: {
                      0: {
                          items: 1,
                          dots: true
                      },
                      768: {
                          items: 2,
                          dots: true
                      },
                      1280: {
                          items: 4,
                          dots: true
                      }
                  }
              }).on('changed.owl.carousel', function(event) {
                  let currentIndex = event.item.index;
                  let totalItems = event.item.count;
                  let pageSize = event.page.size;
      
                  if (currentIndex === 0) {
                      $floatNav.find('.owl-prev').prop('disabled', true);
                  } else {
                      $floatNav.find('.owl-prev').prop('disabled', false);
                  }
      
                  if (currentIndex >= totalItems - pageSize) {
                      $floatNav.find('.owl-next').prop('disabled', true);
                  } else {
                      $floatNav.find('.owl-next').prop('disabled', false);
                  }
              });
      
              $floatNav.find('.owl-prev').on('click', function() {
                  owl.trigger('prev.owl.carousel');
              });
              $floatNav.find('.owl-next').on('click', function() {
                  owl.trigger('next.owl.carousel');
              });
          });

    }

    // SUPPORT ASSEMBLY
    if ($('.assembly-test-section').length) {
      
        $('.tab-container-list').each(function(){
            var $container = $(this); 
            $container.find('.tab-menu').click(function(){
                $('.tab-menu').removeClass('active');
                $(this).addClass('active');
                $('.assembly-test-section .youtube-list-container').addClass('hidden');
                $('.assembly-test-section .youtube-list-container[data-tab="' + $(this).attr('data-tab') + '"]').removeClass('hidden');
            });
        });
            
        const itemsPerPage = 6; // Number of items per page
      
        // Initialize pagination for each .yt-section
        $('.yt-section').each(function () {
          const $section = $(this); // Current section
          const $items = $section.find('.youtube-item'); // Items in the current section
          const $paginationContainer = $section.find('.pagination-numbers'); // Pagination container for the current section
          const $prevButton = $section.find('.paginate .fa-chevron-left').parent();
          const $nextButton = $section.find('.paginate .fa-chevron-right').parent();
          const totalItems = $items.length;
          const totalPages = Math.ceil(totalItems / itemsPerPage);
      
          // Initialize pagination
          function initPagination() {
            $paginationContainer.empty();
            renderPagination(1);
            showPage(1);
            updateNavigationButtons(1);
          }
      
          // Render pagination numbers with limits
          function renderPagination(currentPage) {
            $paginationContainer.empty();
      
            if (totalPages <= 5) {
              // Show all pages if total pages are less than or equal to 5
              for (let i = 1; i <= totalPages; i++) {
                $paginationContainer.append(
                  `<a class="page ${i === currentPage ? 'active' : ''}" href="javascript:void(0)" data-i="${i}">${i}</a>`
                );
              }
            } else {
              // Show limited pages
              if (currentPage <= 3) {
                for (let i = 1; i <= 4; i++) {
                  $paginationContainer.append(
                    `<a class="page ${i === currentPage ? 'active' : ''}" href="javascript:void(0)" data-i="${i}">${i}</a>`
                  );
                }
                $paginationContainer.append('<span class="dots">...</span>');
                $paginationContainer.append(
                  `<a class="page" href="javascript:void(0)" data-i="${totalPages}">${totalPages}</a>`
                );
              } else if (currentPage >= totalPages - 2) {
                $paginationContainer.append(
                  `<a class="page" href="javascript:void(0)" data-i="1">1</a>`
                );
                $paginationContainer.append('<span class="dots">...</span>');
                for (let i = totalPages - 3; i <= totalPages; i++) {
                  $paginationContainer.append(
                    `<a class="page ${i === currentPage ? 'active' : ''}" href="javascript:void(0)" data-i="${i}">${i}</a>`
                  );
                }
              } else {
                $paginationContainer.append(
                  `<a class="page" href="javascript:void(0)" data-i="1">1</a>`
                );
                $paginationContainer.append('<span class="dots">...</span>');
                for (let i = currentPage - 1; i <= currentPage + 1; i++) {
                  $paginationContainer.append(
                    `<a class="page ${i === currentPage ? 'active' : ''}" href="javascript:void(0)" data-i="${i}">${i}</a>`
                  );
                }
                $paginationContainer.append('<span class="dots">...</span>');
                $paginationContainer.append(
                  `<a class="page" href="javascript:void(0)" data-i="${totalPages}">${totalPages}</a>`
                );
              }
            }
          }
      
          // Show items for the selected page
          function showPage(page) {
            const start = (page - 1) * itemsPerPage;
            const end = start + itemsPerPage;
      
            $items.hide().slice(start, end).fadeIn();
            renderPagination(page);
            updateNavigationButtons(page);
          }
      
          // Update navigation button states
          function updateNavigationButtons(currentPage) {
            $prevButton.toggleClass('disable', currentPage === 1);
            $nextButton.toggleClass('disable', currentPage === totalPages);
          }
      
          // Handle pagination click events
          $paginationContainer.on('click', '.page', function () {
            const page = parseInt($(this).attr('data-i'));
            if (!$(this).hasClass('active')) {
              showPage(page);
            }
          });
      
          // Handle previous and next button click events
          $prevButton.on('click', function () {
            const currentPage = parseInt($paginationContainer.find('.page.active').attr('data-i'));
            if (currentPage > 1) {
              showPage(currentPage - 1);
            }
          });
      
          $nextButton.on('click', function () {
            const currentPage = parseInt($paginationContainer.find('.page.active').attr('data-i'));
            if (currentPage < totalPages) {
              showPage(currentPage + 1);
            }
          });
      
          // Initialize pagination for the current section
          initPagination();
        });
    }

    // SALE BANNER 
    if ($('.sale-banner').length) {
        var countdownInterval = setInterval(function() {
            var now = new Date().getTime();
            
            var timeDifference = targetDate - now;
            
            var days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            var hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
            
            days = days < 10 ? '0' + days : days;
            hours = hours < 10 ? '0' + hours : hours;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            seconds = seconds < 10 ? '0' + seconds : seconds;
            
            $('.day-sec').text(days);
            $('.hour-sec').text(hours);
            $('.minute-sec').text(minutes);
            $('.second-sec').text(seconds);
            
            if (timeDifference < 0) {
                clearInterval(countdownInterval);
                $('.day-sec, .hour-sec, .minute-sec, .second-sec').text('00');
            }
        }, 1000);
    }

    // SALE PROMO BANNER
    if ($('.promo-banner').length) {
      $('.promo-banner .btn-guidelines').click(() => {
        $('.promo-banner .custom-modal-section').addClass('open');
        $('body').addClass('no-scroll');
      });
      
      $('.custom-modal-section .overlay, .custom-modal-section .custom-close').click(() => {
        $('.custom-modal-section').removeClass('open');
        $('body').removeClass('no-scroll');
      });
    }

    // SALE RECOMMENDATION
    if ($('.sale-recommendation-section').length) {
      
        $('.youtube-list-container .youtube').each(function() {
          let videoId = $(this).data('yt');
          let thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
          $(this).css('background-image', `url(${thumbnailUrl})`);
      });
      
        const iframes = document.querySelectorAll('.youtube-list-container .youtube');
        iframes.forEach((iframe, index) => {
            const videoId = $(iframe).data('yt');
            const apiUrl = `https://noembed.com/embed?url=https://www.youtube.com/watch?v=${videoId}`;
    
            fetch(apiUrl)
                .then(response => response.json())
                .then(data => {
                    const titleElement = document.getElementsByClassName('video-title')[index];
    
                    titleElement.textContent = data.title;
                })
                .catch(error => {
                    console.error('Error fetching video details:', error);
                    const titleElement = document.getElementsByClassName('video-title')[index];
    
                    titleElement.textContent = 'Error fetching video title';
                    authorNameElement.textContent = 'Error fetching author name';
                });
        });
    
    
      
        $('.sale-recommendation-section .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');

            let owl = $carousel.owlCarousel({
                items: 3,
                nav: true,
                dots: false,
                smartSpeed: 800,
                margin: 20,
                responsive: {
                    0: {
                        items: 1,
                        dots: true
                    },
                    768: {
                        items: 2,
                        dots: true
                    },
                    1280: {
                        items: 3,
                        dots: false
                    }
                }
            }).on('changed.owl.carousel', function(event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;

                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }

                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });

            $floatNav.find('.owl-prev').on('click', function() {
                owl.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                owl.trigger('next.owl.carousel');
            });
        });
    }

    // User Manual Download
    if ($('.user-manual-download-section').length) {
        $('.tab-container-list').each(function(){
          var $container = $(this); 
          $container.find('.tab-menu').click(function(){
              $('.tab-menu').removeClass('active');
              $(this).addClass('active');
              $('.umd-list-container').addClass('hidden');
              $('.umd-list-container[data-tab="' + $(this).attr('data-tab') + '"]').removeClass('hidden');
          });
        });
        
        
        document.getElementById('input-search').addEventListener('input', function () {
          const searchTerm = this.value.toLowerCase();
          const containers = document.querySelectorAll('.umd-list-container');
          
          containers.forEach(container => {
            const items = container.querySelectorAll('.manual-item');
            items.forEach(item => {
              const title = item.getAttribute('item-title').toLowerCase();
              if (title.includes(searchTerm)) {
                item.style.display = 'block';
              } else {
                item.style.display = 'none';
              }
            });
          });
        });
    }

    // RIDER STORIES
    if ($('.rider-stories-section').length) {
      
        if ($('.paginate').find('.page:not(.disable)').length > 0)
            $('.paginate').css('display', 'flex');
        else
            $('.paginate').css('display', 'none');
    
        
          $(document).on('click', '.paginate a', function(e) {
              e.preventDefault();
      
              let newUrl = $(this).attr('href');
            filter(newUrl);
      
              $('html, body').animate({
                  scrollTop: $('.blog-container').offset().top - 50
              }, 0);
          });
    }

    // Warranty Claim
    if ($('.warranty-claim-section').length) {

        $.ajax({
          url: "https://restcountries.com/v3.1/all",
          method: "GET",
          dataType: "json",
          success: function (data) {
            let countryList = $("#country-list");
            data.sort((a, b) => a.name.common.localeCompare(b.name.common)); // Sort alphabetically
      
            $.each(data, function (index, country) {
              let countryItem = $("<p></p>")
                .text(country.name.common)
                .attr("data-value", country.cca2)
                .addClass("mx-0");
      
              // Click event to set the input value
              countryItem.on("click", function () {
                $("#country-input").val($(this).text());
              });
      
              countryList.append(countryItem);
            });
          },
          error: function (xhr, status, error) {
            console.error("Error fetching countries:", error);
          }
        });

        $('.custom-input-box').each(function(){
            var $container = $(this);
            var $input = $container.find('.custom-input');
            var $options = $container.find('.select-tag-option p');
            var $followUpContainer = $('.custom-input-box.follow-up');
            var $followUpInput = $followUpContainer.find('.custom-input');
            var $followUpOptions = $followUpContainer.find('.select-tag-option');
        
            // Define the options based on the selected service
            var optionsMapping = {
                
            };
        
            // Handle click on product option
            $options.click(function(event){
                var selectedText = $(this).text();
        
                // Set the value and placeholder in the services-follow input
                $input.val(selectedText).attr('placeholder', selectedText);
        
                // Clear the visible text on focus, but retain the value
                $input.focus(function() {
                    $(this).val(''); // Clear the input text when focused
                }).blur(function() {
                    // If no new text is entered, restore the selected value
                    if (!$(this).val()) {
                        $(this).val(selectedText);
                    }
                });
        
                // Update the follow-up options based on the selected service
                if (optionsMapping[selectedText]) {
                    $followUpOptions.empty(); // Clear previous options
                    optionsMapping[selectedText].forEach(function(option) {
                        $followUpOptions.append('<p class="mx-0">' + option + '</p>');
                    });
                } else {
                    $followUpOptions.empty(); // Clear if no mapping exists
                }
            });
        
            // Handle click on follow-up options
            $followUpOptions.on('click', 'p', function() {
                var followUpSelectedText = $(this).text();
        
                // Set the value and placeholder in the follow-up input
                $followUpInput.val(followUpSelectedText).attr('placeholder', followUpSelectedText);
        
                // Clear the visible text on focus, but retain the value
                $followUpInput.focus(function() {
                    $(this).val(''); // Clear the input text when focused
                }).blur(function() {
                    // If no new text is entered, restore the selected value
                    if (!$(this).val()) {
                        $(this).val(followUpSelectedText);
                    }
                });
            });
        
            // Filter options based on input value for services-follow
            $input.on('input', function() {
                var searchText = $(this).val().toLowerCase();
        
                // Show or hide options based on search text
                $options.each(function() {
                    var optionText = $(this).text().toLowerCase();
                    if (optionText.includes(searchText)) {
                        $(this).show(); // Show matching option
                    } else {
                        $(this).hide(); // Hide non-matching option
                    }
                });
            });
        
            // Filter options based on input value for follow-up
            $followUpInput.on('input', function() {
                var searchText = $(this).val().toLowerCase();
        
                // Show or hide options based on search text
                $followUpOptions.children('p').each(function() {
                    var optionText = $(this).text().toLowerCase();
                    if (optionText.includes(searchText)) {
                        $(this).show(); // Show matching option
                    } else {
                        $(this).hide(); // Hide non-matching option
                    }
                });
            });
        });
    }

    
    // Main Blog Article Section
    if ($('.blog-article-section').length) {
      $('.filter-tag-container').each(function(){
          var $container = $(this); 
        
          $container.find('.filter-item').click(function(e){
              e.preventDefault();
            
              let newUrl = $(this).attr('href');
              filter(newUrl);
            
              $('.filter-tag-container .filter-item').removeClass('active');
              $(this).addClass('active');
             
          });
      });

      $('.filter-tag-selector').click(function(){
        $('.filter-tag-mobile-selector').addClass('active');
      });
      $('.filter-tag-mobile-selector .overlay, .filter-tag-mobile-selector .close-btn').click(function(){
        $('.filter-tag-mobile-selector').removeClass('active');
      });
      
      $('.filter-tagged-selector').each(function(){
          var $container = $(this); 
        
          $container.find('.filter-content a').click(function(e){
              e.preventDefault();
            
              let newUrl = $(this).attr('href');
              filter(newUrl);
            
              $('.filter-tagged-selector .filter-content a').removeClass('active');
              $(this).addClass('active');
             
          });
      });
      
    
      if ($('.paginate').find('.page:not(.disable)').length > 0)
          $('.paginate').css('display', 'flex');
      else
          $('.paginate').css('display', 'none');
  
      
        $(document).on('click', '.paginate a', function(e) {
            e.preventDefault();
    
            let newUrl = $(this).attr('href');
            filter(newUrl);
    
            $('html, body').animate({
                scrollTop: $('.filter-tag-container').offset().top - 200
            }, 0);
        });
    }

    // Refer A Friend Section
    if ($('.refer-a-friend-section').length) {

        $('.icons-mobile-slider .owl-carousel').each(function () {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');
    
            $carousel.owlCarousel({
                items: 1,
                nav: true,
                autoHeight: true,
                dots: true,
                smartSpeed: 800,
                margin: 20,
                stagePadding: 0
            }).on('changed.owl.carousel', function (event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;
    
                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }
    
                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });
    
            $floatNav.find('.owl-prev').on('click', function () {
                $carousel.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function () {
                $carousel.trigger('next.owl.carousel');
            });
            $(this).trigger('refresh.owl.carousel');
        });
    }

  
    // Article More Post Section
    if ($('.article-more-post').length) {

        $('.more-post-container-slider .owl-carousel').each(function () {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');
    
            $carousel.owlCarousel({
                items: 1,
                nav: true,
                autoHeight: true,
                dots: true,
                smartSpeed: 800,
                margin: 20,
                stagePadding: 0
            }).on('changed.owl.carousel', function (event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;
    
                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }
    
                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });
    
            $floatNav.find('.owl-prev').on('click', function () {
                $carousel.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function () {
                $carousel.trigger('next.owl.carousel');
            });
            $(this).trigger('refresh.owl.carousel');
        });
    }
  
});



function filter(newUrl) {

    $.ajax({
        type: "GET",
        url: newUrl,
        success: function(data) {

            console.log(data);
            //desktop update product list
            if ($(data).find('.blog-container').find('.custom-artice-card-item').length > 0) {
                $('.blog-container').html($(data).find('.blog-container').html());
              
            }
            //show hide pagination
            if ($('.paginate').find('.page:not(.disable)').length > 0)
                $('.paginate').css('display', 'flex');
            else
                $('.paginate').css('display', 'none');


        },
        error: function() {
            console.log("Error occurred while filtering products.");
            $('.blog-container').empty();
        },
    });

    if (window.history && window.history.pushState) {
        window.history.pushState(null, null, newUrl);
    }
}